import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseCardInstallments = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterHome, setValuesCardsInstallmentsHome } = useMetricsContext();

  const handleSubmit = () => {
    api
      .get(
        `/metrics/installments?start_date=${filterHome.startDate}
        &end_date=${filterHome.endDate}
        &is_received=TRUE
        &tipo_contrato=${filterHome.tipo_contrato}`
      )
      .then(({ data }) => setValuesCardsInstallmentsHome(data.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleSubmit };
};
